<h2 mat-dialog-title data-test="dialog">{{ data.title }}</h2>
<div mat-dialog-content>
  <agr-form [formGroup]="formGroup">
    <div class="spacing--margin-vertical">
      <button type="button" mat-stroked-button (click)="file.click()" data-test="file-button">
        {{ selectedFile ? selectedFile.name : ('selectFile' | translate) }}
      </button>
    </div>
    <input
      hidden
      (change)="onFileSelected()"
      #file
      type="file"
      accept=".json"
      data-test="file-input"
    />
  </agr-form>
</div>
<div mat-dialog-actions data-test="dialogButtons">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedFile"
    (click)="confirm({ file: selectedFile })"
    data-test="dialog-submit"
  >
    {{ data.confirmButtonText }}
  </button>
  <button mat-stroked-button data-test="dialog-cancel" (click)="cancel()">
    {{ data.cancelButtonText }}
  </button>
</div>
